import { stepControlsContextObj, useFormContext } from '@cian/frontend-request-form-widget';
import { Button, useDeviceType } from '@cian/ui-kit';
import * as React from 'react';
import { useResponsiveButtonSize } from '../../utils/hooks';
import { useApplicationContext } from '../ApplicationContext';
import { jsx as _jsx } from "react/jsx-runtime";
export var ButtonPrevContainer = function ButtonPrevContainer() {
  var _useApplicationContex = useApplicationContext(),
    layoutConfiguration = _useApplicationContex.layoutConfiguration;
  var _React$useContext = React.useContext(stepControlsContextObj),
    isFirstStep = _React$useContext.isFirstStep,
    currentStepCount = _React$useContext.currentStepCount,
    setPrevStep = _React$useContext.setPrevStep;
  var _useFormContext = useFormContext(),
    isSubmitting = _useFormContext.isSubmitting;
  var deviceType = useDeviceType();
  var size = useResponsiveButtonSize();
  var text = currentStepCount === 1 ? 'Сменить тему' : 'Назад';
  var isPhone = deviceType === 'phone';
  if (isFirstStep || !layoutConfiguration.footer.prevButton.enabled) {
    return null;
  }
  return /*#__PURE__*/_jsx(Button, {
    "data-testid": "prevQ",
    type: "button",
    theme: "fill_secondary",
    fullWidth: isPhone,
    size: size,
    disabled: isSubmitting,
    onClick: setPrevStep,
    children: text
  });
};